import { useState, useEffect, createContext, useContext } from "react";
import { API_URL } from "@/config";

const TechContext = createContext();

export const useTechs = () => {
  const context = useContext(TechContext);
  if (!context) {
    throw new Error('useTechs must be used within a TechProvider');
  }
  return context;
};

export const TechProvider = ({ children }) => {
  const [techs, setTechs] = useState([]);

  useEffect(() => {
    const fetchTechs = async () => {
      try {
        const res = await fetch(`${API_URL}/api/techs`);
        const data = await res.json();
        setTechs(data);
      } catch (err) {
        console.error('Failed to fetch techs:', err);
      }
    };
    fetchTechs();
  }, []);

  const addTech = async (tech) => {
    try {
      const res = await fetch(`${API_URL}/api/techs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tech)
      });
      const newTech = await res.json();
      setTechs(prev => [...prev, newTech]);
    } catch (err) {
      console.error('Failed to add tech:', err);
    }
  };

  const updateTech = async (techId, updatedData) => {
    try {
      const res = await fetch(`${API_URL}/api/techs/${techId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedData)
      });
      const updated = await res.json();
      setTechs(prev => prev.map(t => t.id === techId ? updated : t));
    } catch (err) {
      console.error('Failed to update tech:', err);
    }
  };

  const deleteTech = async (techId) => {
    try {
      await fetch(`${API_URL}/api/techs/${techId}`, { method: 'DELETE' });
      setTechs(prev => prev.filter(t => t.id !== techId));
    } catch (err) {
      console.error('Failed to delete tech:', err);
    }
  };

  return (
    <TechContext.Provider value={{ techs, addTech, updateTech, deleteTech }}>
      {children}
    </TechContext.Provider>
  );
};
